module.exports = __webpack_public_path__ + "static/img/gfk-logo.43869df.jpg";